var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputformIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5C20 7.463 17 5 17 5C17 5 14 7.463 14 10.5C14 13.537 15.344 15 17 15C18.656 15 20 13.537 20 10.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3305 19.3291C15.3755 18.2851 15.2995 16.5161 13.3835 14.6011C11.4695 12.6841 8.0235 13.0231 8.0235 13.0231C8.0235 13.0231 7.6825 16.4681 9.5985 18.3831C11.5185 20.2991 13.2875 20.3741 14.3305 19.3291Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.291 27.452C13.276 28.615 15.21 27.81 15.821 26.125C16.435 24.441 15.497 22.514 12.51 21.351C9.528 20.186 6 22.294 6 22.294C6 22.294 7.308 26.289 10.291 27.452Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17V22C16 22.553 16.447 23 17 23C17.553 23 18 22.553 18 22V17C18 16.447 17.553 16 17 16C16.447 16 16 16.447 16 17Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9064 19.9528C21.8324 19.2018 22.9674 18.7028 24.2114 18.5528C24.2754 18.4918 24.3364 18.4478 24.4014 18.3838C26.3174 16.4688 25.9774 13.0238 25.9774 13.0238C25.9774 13.0238 22.5334 12.6838 20.6184 14.6008C18.7024 16.5158 18.6284 18.2858 19.6724 19.3288C20.0114 19.6688 20.4344 19.8748 20.9064 19.9528Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21H24V24H21V26H24V29H26V26H29V24H26V21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputformIcon);
export default __webpack_public_path__ + "static/media/InputformIcon.b0e10f2eac920d8ca2ba83abe546d690.svg";
export { ForwardRef as ReactComponent };